<template functional>
  <v-list class="elevation-1" :class="{ 'margin-bottom': !props.withoutMargin }">
    <template v-for="(pin, index) in props.pins">
      <v-list-tile
        avatar
        :key="pin.pin"
        :disabled="pin.disabled || props.disabled"
        @click="!pin.disabled && listeners.onSelect && listeners.onSelect(pin)"
      >
        <v-list-tile-content>
          <v-list-tile-title><v-icon>fiber_pin</v-icon> {{ pin.pin }}</v-list-tile-title>
          <v-list-tile-sub-title>
            <span>{{ pin.protocol }}://{{ pin.host }}:{{ pin.port }}</span>
          </v-list-tile-sub-title>
        </v-list-tile-content>

        <v-list-tile-action v-if="props.action">
          <v-btn flat icon color="grey" @click.stop="props.action.handler(pin, $event)">
            <v-icon>{{ props.action.icon }}</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
      <v-divider v-if="index + 1 < props.pins.length" :key="index"></v-divider>
    </template>
  </v-list>
</template>

<script>
export default {
  props: {
    pins: Array,
    action: Object,
    emptyMessage: String,
    withoutMargin: Boolean,
    disabled: Boolean,
  },
};
</script>

<style scoped>
.margin-bottom {
  margin-bottom: 56px;
}
</style>



// WEBPACK FOOTER //
// src/components/pin/pins-list.vue